module.exports = __webpack_public_path__ + "img/產品資訊_產品單圖-09.291eb4d2.png";